import React from "react";
import { Alert, Box, Button } from "@mui/material";

interface ReplaceConfirmationProps {
  /** Lowercase noun for the data being replaced, e.g. "addresses". */
  layerNoun: string;
  onCancel(): void;
  onReplace(): void;
}

/**
 * Inline confirmation that proceeding replaces a layer's existing data.
 */
const ReplaceConfirmation: React.FC<ReplaceConfirmationProps> = ({ layerNoun, onCancel, onReplace }) => (
  <Alert severity="warning" variant="compact" icon={false} sx={{ "& .MuiAlert-message": { flexGrow: 1 } }}>
    <Box component="strong" fontWeight={600}>{`Replace ${layerNoun}?`}</Box>
    {` This will replace the ${layerNoun} in this version. Edits you've made to them will be lost.`}
    <Box display="flex" justifyContent="flex-end" gap={0.5} mt={0.75}>
      <Button size="small" onClick={onCancel}>
        Cancel
      </Button>
      <Button variant="contained" size="small" onClick={onReplace}>
        Replace
      </Button>
    </Box>
  </Alert>
);

export default ReplaceConfirmation;
